import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3c562e7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "handler-container" }
const _hoisted_2 = { key: 0 }

import { computed } from "vue";
import Message from "primevue/message";


export default /*#__PURE__*/_defineComponent({
  __name: 'HandlerAccessDenied',
  props: {
    isDenied: { type: Boolean },
    top: {}
  },
  setup(__props: any) {

const topMargin = computed(() => {
  let top = 0;
  if (props.top) {
    top = props.top;
  }
  return `margin-top: ${top}px`;
});

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isDenied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "handler-access-denied",
          style: _normalizeStyle(topMargin.value)
        }, [
          _createVNode(_unref(Message), {
            severity: "info",
            closable: false
          }, {
            default: _withCtx(() => [
              _createTextVNode("У Вас нет доступа к ресурсу. Обратитесь к администратору.")
            ]),
            _: 1
          })
        ], 4))
  ]))
}
}

})